export const openTab = (src) => {
    const iframe = `<iframe width='100%' height='100%' src='${src}'></iframe>`;
    const newTab = window.open(null, '_blank');

    if (!newTab || newTab.closed || typeof newTab.closed === 'undefined') {
        console.log('Tab blocked or not authorized.');
    }else{
        newTab.document.open();
        newTab.document.write(iframe);
        newTab.document.close();
    }
    return newTab;
};

let is_chrome = navigator.userAgent.indexOf('Chrome') > -1;
const is_explorer = navigator.userAgent.indexOf('MSIE') > -1;
const is_firefox = navigator.userAgent.indexOf('Firefox') > -1;
let is_safari = navigator.userAgent.indexOf("Safari") > -1;
const is_opera = navigator.userAgent.toLowerCase().indexOf("op") > -1;
if ((is_chrome) && (is_safari)) { is_safari = false; }
if ((is_chrome) && (is_opera)) { is_chrome = false; }

export const BrowserDetection = {
    is_chrome,
    is_opera,
    is_firefox,
    is_safari,
    is_explorer
};
